module.exports = /******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {};

  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId])
      /******/ return installedModules[moduleId].exports;

    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {}
      /******/
    });

    /******/ // Execute the module function
    /******/ modules[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );

    /******/ // Flag the module as loaded
    /******/ module.l = true;

    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }

  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = modules;

  /******/ // expose the module cache
  /******/ __webpack_require__.c = installedModules;

  /******/ // identity function for calling harmony imports with the correct context
  /******/ __webpack_require__.i = function (value) {
    return value;
  };

  /******/ // define getter function for harmony exports
  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, {
        /******/ configurable: false,
        /******/ enumerable: true,
        /******/ get: getter
        /******/
      });
      /******/
    }
    /******/
  };

  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module['default'];
          }
        : /******/ function getModuleExports() {
            return module;
          };
    /******/ __webpack_require__.d(getter, 'a', getter);
    /******/ return getter;
    /******/
  };

  /******/ // Object.prototype.hasOwnProperty.call
  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };

  /******/ // __webpack_public_path__
  /******/ __webpack_require__.p = '';

  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 221));
  /******/
})(
  /************************************************************************/
  /******/ {
    /***/ 0: /***/ function (module, exports) {
      /* globals __VUE_SSR_CONTEXT__ */

      // this module is a runtime utility for cleaner component module output and will
      // be included in the final webpack user bundle

      module.exports = function normalizeComponent(
        rawScriptExports,
        compiledTemplate,
        injectStyles,
        scopeId,
        moduleIdentifier /* server only */
      ) {
        var esModule;
        var scriptExports = (rawScriptExports = rawScriptExports || {});

        // ES6 modules interop
        var type = typeof rawScriptExports.default;
        if (type === 'object' || type === 'function') {
          esModule = rawScriptExports;
          scriptExports = rawScriptExports.default;
        }

        // Vue.extend constructor export interop
        var options =
          typeof scriptExports === 'function'
            ? scriptExports.options
            : scriptExports;

        // render functions
        if (compiledTemplate) {
          options.render = compiledTemplate.render;
          options.staticRenderFns = compiledTemplate.staticRenderFns;
        }

        // scopedId
        if (scopeId) {
          options._scopeId = scopeId;
        }

        var hook;
        if (moduleIdentifier) {
          // server build
          hook = function (context) {
            // 2.3 injection
            context =
              context || // cached call
              (this.$vnode && this.$vnode.ssrContext) || // stateful
              (this.parent &&
                this.parent.$vnode &&
                this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
              context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyles) {
              injectStyles.call(this, context);
            }
            // register component module identifier for async chunk inferrence
            if (context && context._registeredComponents) {
              context._registeredComponents.add(moduleIdentifier);
            }
          };
          // used by ssr in case component is cached and beforeCreate
          // never gets called
          options._ssrRegister = hook;
        } else if (injectStyles) {
          hook = injectStyles;
        }

        if (hook) {
          var functional = options.functional;
          var existing = functional ? options.render : options.beforeCreate;
          if (!functional) {
            // inject component registration as beforeCreate hook
            options.beforeCreate = existing
              ? [].concat(existing, hook)
              : [hook];
          } else {
            // register for functioal component in vue file
            options.render = function renderWithStyleInjection(h, context) {
              hook.call(context);
              return existing(h, context);
            };
          }
        }

        return {
          esModule: esModule,
          exports: scriptExports,
          options: options
        };
      };

      /***/
    },

    /***/ 1: /***/ function (module, exports) {
      module.exports = require('vue');

      /***/
    },

    /***/ 122: /***/ function (module, exports) {
      // removed by extract-text-webpack-plugin
      /***/
    },

    /***/ 141: /***/ function (module, exports, __webpack_require__) {
      function injectStyle(ssrContext) {
        __webpack_require__(122);
      }
      var Component = __webpack_require__(0)(
        /* script */
        __webpack_require__(63),
        /* template */
        __webpack_require__(192),
        /* styles */
        injectStyle,
        /* scopeId */
        null,
        /* moduleIdentifier (server only) */
        null
      );

      module.exports = Component.exports;

      /***/
    },

    /***/ 192: /***/ function (module, exports) {
      module.exports = {
        render: function () {
          var _vm = this;
          var _h = _vm.$createElement;
          var _c = _vm._self._c || _h;
          return _c(
            'transition',
            {
              attrs: {
                name: 'mint-indicator'
              }
            },
            [
              _c(
                'div',
                {
                  directives: [
                    {
                      name: 'show',
                      rawName: 'v-show',
                      value: _vm.visible,
                      expression: 'visible'
                    }
                  ],
                  staticClass: 'mint-indicator'
                },
                [
                  _c(
                    'div',
                    {
                      staticClass: 'mint-indicator-wrapper',
                      style: {
                        padding: _vm.text ? '20px' : '15px'
                      }
                    },
                    [
                      _c('spinner', {
                        staticClass: 'mint-indicator-spin',
                        attrs: {
                          type: _vm.convertedSpinnerType,
                          size: 32
                        }
                      }),
                      _vm._v(' '),
                      _c(
                        'span',
                        {
                          directives: [
                            {
                              name: 'show',
                              rawName: 'v-show',
                              value: _vm.text,
                              expression: 'text'
                            }
                          ],
                          staticClass: 'mint-indicator-text'
                        },
                        [_vm._v(_vm._s(_vm.text))]
                      )
                    ],
                    1
                  ),
                  _vm._v(' '),
                  _c('div', {
                    staticClass: 'mint-indicator-mask',
                    on: {
                      touchmove: function ($event) {
                        $event.stopPropagation();
                        $event.preventDefault();
                      }
                    }
                  })
                ]
              )
            ]
          );
        },
        staticRenderFns: []
      };

      /***/
    },

    /***/ 205: /***/ function (module, exports) {
      module.exports = require('mint-ui/lib/spinner');

      /***/
    },

    /***/ 206: /***/ function (module, exports) {
      module.exports = require('mint-ui/lib/spinner/style.css');

      /***/
    },

    /***/ 221: /***/ function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(29);

      /***/
    },

    /***/ 29: /***/ function (module, exports, __webpack_require__) {
      'use strict';
      Object.defineProperty(exports, '__esModule', { value: true });
      /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ =
        __webpack_require__(1);
      /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default =
        __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

      var Indicator = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(
        __webpack_require__(141)
      );
      var instance;

      /* harmony default export */ exports['default'] = {
        open: function open(options, opt = {}) {
          if (options === void 0) options = {};

          if (!instance) {
            instance = new Indicator({
              el: document.createElement('div')
            });
          }
          if (instance.visible && !opt.forceUpdate) return;
          instance.text =
            typeof options === 'string' ? options : options.text || '';
          instance.spinnerType = options.spinnerType || 'snake';
          document.body.appendChild(instance.$el);

          __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
            instance.visible = true;
          });
        },

        close: function close() {
          if (instance) {
            instance.visible = false;
          }
        }
      };

      /***/
    },

    /***/ 63: /***/ function (module, exports, __webpack_require__) {
      'use strict';
      Object.defineProperty(exports, '__esModule', { value: true });
      /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_index_js__ =
        __webpack_require__(205);
      /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_index_js___default =
        __webpack_require__.n(
          __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_index_js__
        );
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //
      //

      if (true) {
        __webpack_require__(206);
      }

      /* harmony default export */ exports['default'] = {
        data: function data() {
          return {
            visible: false
          };
        },

        components: {
          Spinner:
            __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_index_js___default.a
        },

        computed: {
          convertedSpinnerType: function convertedSpinnerType() {
            switch (this.spinnerType) {
              case 'double-bounce':
                return 1;
              case 'triple-bounce':
                return 2;
              case 'fading-circle':
                return 3;
              default:
                return 0;
            }
          }
        },

        props: {
          text: String,
          spinnerType: {
            type: String,
            default: 'snake'
          }
        }
      };

      /***/
    }

    /******/
  }
);
